import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reemplazar'
})
export class ReemplazarPipe implements PipeTransform {

  transform(value: string, reemplazar:string, con:string): string {
    
      for(let i=0; i<50; i++){
        value = value.replace(reemplazar, con)
      }

    return value
  }

}
